<template>
  <zh-table-page
    ref="tableRef"
    v-bind="{
      title: '消息管理',
      search,
      api,
      afterGetDetail,
      beforeSave,
      ...table,
      ...dialog,
    }"
  >
  <!-- <template #header-btn>
    <el-button type="primary" @click="clickPush">推送消息</el-button>
  </template> -->
  </zh-table-page>
  <!-- <zh-form-dialog v-model="dialogVisible" :formItems="formItems"
      :formModel="formModel" title="推送消息" :rules="formRules" @submit="submit"></zh-form-dialog> -->
</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox } from "element-plus";
import moment from "moment"
export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const state = reactive({
      search: [
        {
          label: "推送配置id",
          placeholder: "推送配置id",
          value: "configId",
        },
      ],
      api: {
        list: "postMessagePage",
        delete: "",
        add: "",
        edit: "",
        detail: "getMessage",
        tree: "",
      },
      table: {
        columns: [
          { label: "推送配置id", prop: "configId" },
          { label: "推送内容", prop: "content" },
          { label: "异常信息", prop: "error",scopeComponent:'el-text' },
          { label: "推送状态", prop: "messageStatus", 
          scopeFun: (scope) => {
            if (scope.row.messageStatus) {
              return scope.row.messageStatus.desc;
            }
            return '--'

          },
          },
          { label: "重试次数", prop: "retry" },
          { label: "消息备注", prop: "remark" },

                 ],
        operations: [],
        rowKey: "id",
      },
      dialog: {
        dialogForm: [
          {
            label: "端口号",
            placeholder: "请输入端口号",
            value: "portNumber",
          },
          {
            component: "zh-select",
            label: "服务器",
            placeholder: "请选择服务器",
            value: "serverId",
            url:"postServerList",
            field: {
              id: "value",
              serverName: "label",
            },
          },
          {
            component: "zh-select",
            label: "是否被占用",
            placeholder: "请选择是否被占用",
            value: "occupancy",
            defaultValue:0,
            options:[
              {value:1,label:'被占用 '},
              {value:0,label:'未被占用 '},
            ],
          },
          {
            component: "zh-select",
            label: "是否对内开启",
            placeholder: "请选择是否对内开启",
            value: "openInternally",
            defaultValue:1,
            options:[
              {value:1,label:'开启 '},
              {value:0,label:'未开启 '},
            ],
          },
          {
            component: "zh-select",
            label: "是否对外开启",
            placeholder: "请选择是否对外开启",
            value: "openPublic",
            defaultValue:1,
            options:[
              {value:1,label:'开启 '},
              {value:0,label:'未开启 '},
            ],
          },
          
        ],
        dialogRules: {
          portNumber: [
            { required: true, message: "端口号不能为空", trigger: "blur" },
          ],
          serverId: [
            { required: true, message: "请选择服务器", trigger: "blur" },
          ],
          occupancy: [
            { required: true, message: "请选择是否被占用不能为空", trigger: "blur" },
          ],
          openInternally: [
            { required: true, message: "请选择是否对内开启不能为空", trigger: "blur" },
          ],
          openPublic: [
            { required: true, message: "请选择是否对外开启", trigger: "blur" },
          ],
        
         
        },
      },
      formItems:[],
      formRules:[],
      formModel:{},
      dialogVisible:false
    });
    onMounted(() => {
    });
    //点击编辑处理详情数据
    const afterGetDetail = (data) => {
      return {
        ...data,
       
      };
    };
    //新增编辑保存之前
    const beforeSave = (form)=>{
      return {
        ...form,
        portNumber:Number(form.portNumber)
      }
    }
    //点击推送消息
    const clickPush = ()=>{
      console.log('点击推送消息')
      state.dialogVisible = true
    }
    //推送消息提交
    const submit = ()=>{

    }
    return {
      ...toRefs(state),
      tableRef,
      afterGetDetail,
      beforeSave,
      submit,
      clickPush,
    };
  },
});
</script>
